function y(a, o, s, l) {
  let t = 1 / 0, m = -1 / 0, n = 1 / 0, f = -1 / 0;
  for (const e of a)
    t = Math.min(t, e[0]), m = Math.max(m, e[0]), n = Math.min(n, e[2]), f = Math.max(f, e[2]);
  const i = [m - t, l, f - n], x = [
    t + o[0] * i[0],
    s + o[1] * i[1],
    n + o[2] * i[2]
  ];
  return { size: i, pos: x };
}
export {
  y as getPolySizeAndPos
};
//# sourceMappingURL=index15.js.map
